import secureApi from "../services/secureApi";


export const getProfitReport = async (params = {}) => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

  const response = await secureApi.get("/admin/reports/profit", {
    params: cleanedParams,
  });
  return response.data;
};

export const getTaxReport = async (params = {}) => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

  const response = await secureApi.get("/admin/reports/tax", {
    params: cleanedParams,
  });
  return response.data;
};

export const getPaymentReport = async (params = {}) => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

  const response = await secureApi.get("/admin/reports/payments", {
    params: cleanedParams,
  });
  return response.data;
};

export const getCourierReport = async (params = {}) => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

  const response = await secureApi.get("/admin/reports/courier", {
    params: cleanedParams,
  });

  return response.data;
};
